export const snowDaysAgo = (date: string) => {
  const difference = Math.abs(Date.now() - new Date(date).getTime());
  return difference / (1000 * 60 * 60 * 24);
};
